import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  ListJournalMouvementsCaisse,
  findMouvementsCaisseByJournalApi,
  listMouvementsCaisseCommandeBySession,
  listMouvementsCaisseParSession,
} from "../../_App/Redux/Slices/mouvementCaisse/MouvementCaisseSlice";
import {
  SelectedOrganisationId,
  selectUser,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { useParams } from "react-router-dom";
import {
  Journal,
  getJournalCaisseByIdApi,
  updateJournal,
} from "../../_App/Redux/Slices/journalCaisse/journalCaisseSlice";
import {
  exportExcel,
  exportExcelNoHeader,
  formadate,
  formatDateAndTime,
} from "../../_App/Helpers/helpers";
import NavbarCaisse from "../../_Layouts/Navbar/NavbarCaisse";
import NavbarDefault from "../../_Layouts/Navbar/NavbarDefault";
import Navbar from "../../_Layouts/Navbar/Navbar";
import GenerationFactureModal from "../../Components/Caisses/JournalCaisse/GenerationFactureModal";
import { MouvementCaisseType } from "../../_App/Types/Entites/MouvementCaisseType";
import { useTranslation } from "react-i18next";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import Swal from "sweetalert2";
import OrderDetailsModal from "../../Components/Caisses/Orders/OrderDetailsModal";
import {
  ArticleData,
  OrderType,
} from "../../_App/Types/Entites/Orders/OrderType";
import {
  findreglementsAPi,
  findReglementsByJournalApi,
} from "../../_App/Redux/Slices/payments/PaymentSlice";
import { Toast } from "react-bootstrap";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";

const MouvementsJournal = () => {
  let { id } = useParams<{ id?: string }>(); // Explicitly define the type
  const [filtre, setFiltre] = useState({
    organisation: undefined,
    dateFin: undefined,
    dateDebut: undefined,
    listcaissiers: [],
    listvendeur: [],
    status: undefined,
    type: undefined,
    numOrder: undefined,
    index: 1,
    keyword: "",
    societe_id: undefined,
    journal_id: id,
  });
  const [reglements, setReglements] = useState<any>({});
  const [typePayment, setTypePayment] = useState<any>();
  const dispatch = useAppDispatch();
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const journal = useAppSelector(Journal);
  const { t } = useTranslation();

  const user = useAppSelector(selectUser);

  const sessionXorderMouvements = useAppSelector(
    listMouvementsCaisseCommandeBySession,
  );

  const mouvementsCaisseParJournal = useAppSelector(
    ListJournalMouvementsCaisse,
  );

  useEffect(() => {
    const fetch = async () => {
      if (currentOrganisation && id) {
        dispatch(findMouvementsCaisseByJournalApi(id));
        dispatch(getJournalCaisseByIdApi(id));
      }
    };
    fetch();
  }, [currentOrganisation, id]);

  const parametrages = useAppSelector(parametrageCaisse);

  const CalculateRecette = (
    mouvements: MouvementCaisseType[] = [],
    fondInitial: number = 0,
  ): any => {
    const total = mouvements.reduce((totalFond, operation) => {
      console.log('operation.montant',operation)
        if (operation.type_mouvement_id?.sens === "c") {
          return totalFond + operation.montant;
        } else {
          
          return operation.montant<0 ?  totalFond + operation.montant: totalFond - operation.montant;
        }
      
    }, fondInitial);

    return total.toFixed(3); // Still a string
  };

  const seenOrders = new Set();
  const chiffreDAffaire = mouvementsCaisseParJournal?.reduce(
    (sum: number, operation: any) => {
      const order = operation.order_id;
      const findAvancePayee = mouvementsCaisseParJournal.find(
        (m) =>
          m?.order_id?._id === order?._id &&
          m?.ticket_id?.type === "Total" &&
          m?.journal_id?._id === id,
      );
      if (order && !seenOrders.has(order?._id) && findAvancePayee) {
        seenOrders.add(order?._id);
        return sum + (order.totalNet || 0);
      }
      return sum;
    },
    0,
  );

  const CalculateTotal = (
    mouvements: MouvementCaisseType[],
    calculationType:
      | "vente"
      | "apport"
      | "retrait"
      | "especes"
      | "giftCard"
      | "creditCard"
      | "cheques"
      | "Points fidelité"
      | "Tickets cadeaux"
      | "Carte bancaire"
      | "avance"
      | "bon"
      | "Traite"
      | "Carte sedexo",
  ) => {
    const total = mouvements.reduce((sum, operation) => {
      switch (calculationType) {
        case "vente":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            (operation.type_mouvement_id?.libelle === "Vente" ||
              operation.type_mouvement_id?.libelle === "Annulation")
          ) {
            return sum + operation.montant;
          }

          break;

        case "apport":
          if (parametrages?.methodeCloture === "cashOnly") {
            if (
              operation.type_mouvement_id?.sens === "c" &&
              operation.payment_method === "Cash" &&
              operation.type_mouvement_id?.libelle !== "Vente" &&
              operation.type_mouvement_id?.libelle !== "Annulation"
            ) {
              return sum + operation.montant;
            }
          } else {
            if (
              operation.type_mouvement_id?.sens === "c" &&
              operation.type_mouvement_id?.libelle !== "Vente" &&
              operation.type_mouvement_id?.libelle !== "Annulation"
            ) {
              return sum + operation.montant;
            }
          }
          break;

        case "retrait":
          if (parametrages?.methodeCloture === "cashOnly") {
            if (
              operation.type_mouvement_id?.sens === "d" &&
              operation.payment_method === "Cash"
            ) {
              return sum + operation.montant;
            }
          } else {
            if (operation.type_mouvement_id?.sens === "d") {
              return sum + operation.montant;
            }
          }
          break;

        case "especes":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            (operation.payment_method === "Cash" ||
              operation.payment_method === "cash")
          ) {
            return sum + operation.montant;
          }
          break;
        case "giftCard":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            operation.payment_method === "Tickets cadeaux"
          ) {
            return sum + operation.montant;
          }
          break;
        case "Traite":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            operation.payment_method === "Traite"
          ) {
            return sum + operation.montant;
          }
          break;
        case "Carte sedexo":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            operation.payment_method === "Carte sedexo"
          ) {
            return sum + operation.montant;
          }
          break;
        case "creditCard":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            operation.payment_method === "Carte bancaire"
          ) {
            return sum + operation.montant;
          }
          break;

        case "cheques":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            operation.payment_method === "Chéque"
          ) {
            return sum + operation.montant;
          }
          break;

        case "bon":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            operation.payment_method === "bon"
          ) {
            return sum + operation.montant;
          }
          break;
        case "avance":
          if (
            operation.type_mouvement_id?.sens === "c" &&
            operation.ticket_id.type === "Avance" &&
            operation.order_id.status !== "Annulée"
          ) {
            console.log("operation.montant", operation);
            return sum + operation.montant;
          }

          break;

        default:
          break;
      }
      return sum;
    }, 0);

    return total.toFixed(3);
  };

  const [physicalCash, setPhysicalCash] = useState(0);
  const [showModalTicket, setShowModalTicket] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState();

  const handleSubmit = () => {
    console.log(
      physicalCash,
      CalculateRecette(mouvementsCaisseParJournal, journal?.font_initial) -
        (physicalCash + journal?.font_final),
    );
    if (
      CalculateRecette(mouvementsCaisseParJournal, journal?.font_initial) -
        (physicalCash + journal?.font_final) ===
      0
    ) {
      Swal.fire({
        title: "Voulez vous vraiment valider ce journal ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const ecart =
            (CalculateRecette(
              mouvementsCaisseParJournal,
              journal?.font_initial,
            ) -
              (physicalCash + journal?.font_final)) *
            -1;

          const res = await dispatch(
            updateJournal({
              id: journal?._id,
              data: {
                valide: true,
                Validator: user,
                validatorFoundValue: physicalCash,
                ecart: ecart.toFixed(3),
              },
            }),
          );
          if (res.payload.success) {
            window.location.reload();
          }

          Swal.fire("Journal validé avec succés !", "", "success");
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    } else {
      const ecart =
        (CalculateRecette(mouvementsCaisseParJournal, journal?.font_initial) -
          (physicalCash + journal?.font_final)) *
        -1;

      const title = `Ecart de ${ecart > 0 ? "+" : ""}${ecart.toFixed(3)} !`;

      Swal.fire({
        title: title,
        text: "Voulez vous vraiment valider ce journal quand meme ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (result) => {
        if (result.isConfirmed) {
          dispatch(
            await updateJournal({
              id: journal?._id,
              data: {
                valide: true,
                Validator: user,
                validatorFoundValue: physicalCash,

                ecart: ecart.toFixed(3),
              },
            }),
          );
          //   window.location.reload();

          Swal.fire("Journal validé avec succés !", "", "success");
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    }
  };

  const difference = () => {
    const total = CalculateRecette(
      mouvementsCaisseParJournal,
      journal?.font_initial,
    );

    return Number((total - journal?.font_final).toFixed(3));
  };

  useEffect(() => {
    // Calculate the difference when data is available
    const calculatedDifference = difference();
    if (parametrages && parametrages.methodeCloture === "total") {
      setPhysicalCash(0);
    } else if (!isNaN(calculatedDifference)) {
      setPhysicalCash(calculatedDifference);
    }
  }, [journal?.font_final, mouvementsCaisseParJournal]);

  interface DataRow {
    date: string;
    client: string;
    numFacture: string;
    article: string;
    designation: string;
    qte: number;
    total_ttc: number;
    remise: any;
    prixNetHT: number;
    prixNetTTC: any;
    societe: string;
  }
  //   interface DataRowComptable {
  //   V: string;
  //   ICHA: string;
  //   ICHA: string;
  //   1: string;
  //   FAC: string;
  //   IN105: number;
  //   TND: number;
  //   remise: any;
  //   prixNetHT: number;
  //   prixNetTTC: any;
  //   societe: string;
  // }

  const exportToExcel = async (data: any) => {
    const paymentsMap = data[0][1];
    // console.log(paymentsMap);
    const uniqueOrdersMap: OrderType[] = [];

    Object.values(paymentsMap).forEach((paymentArray: any) => {
      paymentArray.forEach((payment: any) => {
        const order = payment.order_id;
        if (order && !uniqueOrdersMap.some((o) => o._id === order._id)) {
          uniqueOrdersMap.push(order);
        }
      });
    });
    console.log(uniqueOrdersMap);
    const list: DataRow[] = uniqueOrdersMap.flatMap((order: OrderType) =>
      order.items.map(
        (item): DataRow => ({
          date: order.date.toString().split("T")[0],
          client: order.client_id.nom,
          numFacture: order.order_number,
          article: item.article.code_article,
          designation: item.article.titre.fr,
          qte: item.quantity,
          total_ttc: item.prix_total,
          remise: item.remise + "%",
          prixNetHT: Number(
            (
              item.article.prix_vente_ht -
              ((item.article.prix_vente_ht * item.remise) / 100) * item.quantity
            ).toFixed(3),
          ),
          prixNetTTC: item.prixNet.toFixed(3),
          societe: order.societe_id.nom,
        }),
      ),
    );

    exportExcel("articles_commandes.xlsx", "articles_commandes", list);
  };

  const exportToExcelComptable = async (data: any) => {
    const paymentsMap = data[0][1];
    const uniqueOrdersMap: OrderType[] = [];

    Object.values(paymentsMap).forEach((paymentArray: any) => {
      paymentArray.forEach((payment: any) => {
        const order = payment.order_id;
        if (order && !uniqueOrdersMap.some((o) => o._id === order._id)) {
          uniqueOrdersMap.push(order);
        }
      });
    });
    const distinctProducts: ArticleData[] = [];
    const products: ArticleData[] = [];
    uniqueOrdersMap.forEach((order: OrderType) => {
      order.items.forEach((item: ArticleData) => {
        const existingItem = products.find(
          (o) => o.article._id === item.article._id && o.remise === item.remise,
        );
        if (existingItem) {
          existingItem.quantity += item.quantity; // Merge quantities
        } else {
          products.push({ ...item }); // Add new product
        }
      });
    });
    uniqueOrdersMap.forEach((order: OrderType) => {
      order.items.forEach((item: ArticleData) => {
        const existingItem = distinctProducts.find(
          (o) => o.article._id === item.article._id && o.remise === item.remise,
        );
        if (existingItem) {
          existingItem.quantity += item.quantity; // Merge quantities
        } else {
          distinctProducts.push({ ...item }); // Add new product
        }
      });
    });

    const dateString = journal?.date; // "2025-06-10T08:27:13.503Z" (ISO format)
    console.log(dateString); // Verify the raw string

    // Convert string to Date object
    const date = dateString ? new Date(dateString) : new Date(); // Fallback to current date if null

    // Format as DDMMYYYY
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const todayFormatted = `${day}${month}${year}`; // "10062025" for June 10, 2025
    const totalTimbres =
      Number(parametrages.timbreTicket) * Object.keys(paymentsMap).length;

    // Create worksheet data
    let index = 100; // Start at 100
    const worksheetData = [
      // Header Row
      [
        "V",
        "ICHA",
        "ICHA",
        "1",
        "FAC",
        "IN105",
        "TND",
        todayFormatted,
        "1",
        "0",
        "2",
        "TAS",
        totalTimbres.toFixed(3),
      ],
      // Product Rows
      ...distinctProducts.map((item) => {
        const currentIndex = index;
        index += 100; // Increment after using the current value
        return [
          "D", // Column 0
          "ICHA", // Column 1
          currentIndex, // Column 2 (100, 200, 300...)
          item.article.code_article, // Column 3
          item.quantity, // Column 4
          item.article.prix_vente_ht.toFixed(3).replace(",", "."), // Column 5
          item.remise.toFixed(3).replace(",", "."), // Column 6
          "NOR", // Column 7
          "", // Column 8
          "0", // Column 9
          "", // Column 10
          "", // Column 11
          "", // Column 12
        ];
      }),
    ];

    exportExcelNoHeader(
      "articles_journal.xlsx",
      "articles_journal",
      worksheetData,
    );
  };

  const exportReglementsToExcel = async (typeP: any) => {
    const res = await dispatch(
      findReglementsByJournalApi({
        ...filtre,
        journal_id: id,
        payment_method: typeP,
      }),
    );
    if (res.payload.data?.details) {
      const data = res.payload?.data?.details;
      let list: any[] = [];
      // Iterate through each payment
      data?.forEach((payment: any) => {
        // First line for each payment
        const day = String(new Date(payment.date).getDate()).padStart(2, "0");
        const month = String(new Date(payment.date).getMonth() + 1).padStart(
          2,
          "0",
        );
        const year = new Date(payment.date).getFullYear();
        const todayFormatted = `${day}${month}${year}`; // "10062025" for June 10, 2025
        const line1 = {
          P: "P",
          ICHA: "ICHA",
          payment_method:
            payment.payment_method === "Espéces"
              ? "ESPECES"
              : payment.payment_method === "Carte bancaire"
              ? "CTPE"
              : payment.payment_method,
          IN105: "IN105",
          ICHA2: "ICHA",

          blank1: "",
          date: todayFormatted, // Format date as needed
          blank2: "",
          blank3: "",
          amount: payment.montant,
          blank4: "",
          ABINE: typeP === "Carte bancaire" ? undefined : "ABINE",
        };

        // Second line for each payment
        const line2 = {
          D: "D",
          TUN: "TUN",
          ENC: "ENC",
          Amount: payment.montant,
          TND: "TND",
          blank5: "",
          blank6: "",
          blank7: "",
          blank8: "",
          blank9: "",
          blank10: "",
          blank11: "",
        };

        // Add both lines to the list
        list.push(line1);
        list.push(line2);
      });

      exportExcelNoHeader(
        `reglements_${typeP}.xlsx`,
        `reglements_${typeP}`,
        list,
      );
    } else {
      ToastWarning("Un problème de changement des règlements ");
    }
  };
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingIni, setIsEditingFIni] = useState(false);

  const [tempValue, setTempValue] = useState(journal?.font_final || 0);
  const [tempValueFini, setTempValueFini] = useState(
    journal?.font_initial || 0,
  );

  useEffect(() => {
    if (journal && journal.font_final) setTempValue(journal.font_final);
  }, [journal]);

  const handleBlur = async (typeFont: string) => {
    if (typeFont === "font_final") {
      setIsEditing(false);

      if (journal.font_final !== tempValue) {
        const result = await Swal.fire({
          title: "Confirmer la modification ?",
          text: "Voulez-vous vraiment mettre à jour le fond de clôture ?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
          reverseButtons: true,
        });

        if (result.isConfirmed) {
          const newEcart = Number(
            (CalculateRecette(
              mouvementsCaisseParJournal,
              journal?.font_initial,
            ) -
              (physicalCash + journal?.font_final)) *
              -1,
          ).toFixed(3);
          const response = await dispatch(
            updateJournal({
              id: journal._id,
              data: { font_final: Number(tempValue), ecart: newEcart },
            }),
          );

          if (response.payload?.success) {
            Swal.fire({
              title: "Succès",
              text: "Le fond de clôture a été mis à jour avec succès.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });

            // Reload data
            dispatch(getJournalCaisseByIdApi(journal._id));
            dispatch(findMouvementsCaisseByJournalApi(journal._id));
          } else {
            Swal.fire({
              title: "Erreur",
              text: "La mise à jour a échoué. Veuillez réessayer.",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } else {
          // If user cancels, just reset value visually
          setTempValue(journal.font_final);
        }
      }
    } else {
      setIsEditingFIni(false);

      if (journal.font_initial !== tempValue) {
        const result = await Swal.fire({
          title: "Confirmer la modification ?",
          text: "Voulez-vous vraiment mettre à jour le fond d'ouverture ?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
          reverseButtons: true,
        });

        if (result.isConfirmed) {
          const newEcart = Number(
            (CalculateRecette(
              mouvementsCaisseParJournal,
              parseFloat(tempValueFini),
            ) -
              (physicalCash + journal?.font_final)) *
              -1,
          ).toFixed(3);
          const response = await dispatch(
            updateJournal({
              id: journal._id,
              data: { font_initial: Number(tempValueFini), ecart: newEcart },
            }),
          );

          if (response.payload?.success) {
            Swal.fire({
              title: "Succès",
              text: "Le fond d'ouverture a été mis à jour avec succès.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });

            // Reload data
            dispatch(getJournalCaisseByIdApi(journal._id));
            dispatch(findMouvementsCaisseByJournalApi(journal._id));
          } else {
            Swal.fire({
              title: "Erreur",
              text: "La mise à jour a échoué. Veuillez réessayer.",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } else {
          // If user cancels, just reset value visually
          setTempValueFini(journal.fond_initial);
        }
      }
    }
  };
  return (
    <>
      <Navbar />

      <div className="d-flex" style={{ width: "100%", margin: "15px 0" }}>
        <div
          className="page-header row"
          style={{ textAlign: "center", width: "100%" }}
        >
          <div className="page-title col-4">
            <h3> {"Journal  " + journal?.code_journal}</h3>
          </div>
          <div className="page-title col-4">
            <h3> {t("Date") + journal?.date?.toString().split("T")[0]}</h3>
          </div>
          <div className="page-title col-4">
            <h3>{"Fond initial " + journal?.font_initial}</h3>
          </div>
        </div>
      </div>
      <div className="dropdown" style={{ marginLeft: "78%" }}>
        <button
          className="btn btn-export dropdown-toggle"
          type="button"
          id="etatsDropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i className="fas fa-file-excel mr-2"></i>
          {t("Export états excel")}
        </button>
        <div className="dropdown-menu" aria-labelledby="etatsDropdown">
          <button
            className="dropdown-item"
            onClick={() =>
              exportToExcel(Object.entries(sessionXorderMouvements))
            }
          >
            {t("Articles commandes")}
          </button>
          <button
            className="dropdown-item"
            onClick={() =>
              exportToExcelComptable(Object.entries(sessionXorderMouvements))
            }
          >
            {t("Articles journal")}
          </button>
          <button
            className="dropdown-item"
            onClick={() => exportReglementsToExcel("Espéces")}
          >
            {t("Réglements Espéces")}
          </button>
          <button
            className="dropdown-item"
            onClick={() => exportReglementsToExcel("Carte bancaire")}
          >
            {t("Réglements TPE")}
          </button>
        </div>
      </div>
      <div className="row layout-spacing">
        <div className="col-lg-12">
          <div className="statbox widget box box-shadow">
            <div className="widget-content widget-content-area">
              <table id="style-2" className="table style-2  table-hover">
                <thead>
                  <tr>
                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("Commande")}
                    </th>
                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("Date")}
                    </th>
                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("Type")}
                    </th>
                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("Motif")}
                    </th>

                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("Status commande")}
                    </th>
                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("Caissier")}
                    </th>
                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("amount")}
                    </th>
                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("Encaissement")}
                    </th>
                    <th style={{ fontSize: "15px", width: "10%" }}>
                      {t("Methode de paiement")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {Object.entries(sessionXorderMouvements).map(
                    ([sessionId, orders]) => {
                      // Récupérer le premier session_id à afficher
                      const sessionLabel =
                        Object.entries(orders)[0][1][0].user_id?.nom;

                      return (
                        <React.Fragment key={sessionId}>
                          {/* Ligne de session */}
                          <tr
                            style={{
                              background: "#a0c4ff",
                              fontWeight: "bold",
                            }}
                          >
                            <td colSpan={9}>Session: {sessionLabel}</td>
                          </tr>

                          {Object.entries(orders).map(
                            ([orderKey, mouvements]) => (
                              <React.Fragment key={orderKey}>
                                {/* Ligne de commande */}
                                <tr>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                    onClick={() => {
                                      setSelectedTicket(
                                        mouvements[0].order_id?._id,
                                      );
                                      setShowModalTicket(true);
                                    }}
                                  >
                                    {orderKey}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                  >
                                    {formatDateAndTime(mouvements[0].date)}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                  >
                                    {mouvements[0].ticket_id?.type === "Avance"
                                      ? t("Avance")
                                      : mouvements[0].type_mouvement_id
                                          ?.libelle}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                  >
                                    {mouvements[0].commentaire || "_"}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                  >
                                    {mouvements[0].order_id?.status}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                  >
                                    {mouvements[0].user_id?.nom}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                  >
                                    {mouvements[0].order_id?.totalNet.toFixed(
                                      3,
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                  ></td>
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      background: "#c7e6e4",
                                    }}
                                  ></td>
                                </tr>

                                {/* Détails des mouvements */}
                                {mouvements.map((item: any) => (
                                  <tr key={item._id}>
                                    <td colSpan={7}></td>
                                    <td style={{ fontSize: "15px" }}>
                                      {mouvements[0].type_mouvement_id?.sens ===
                                      "d"
                                        ? -item.montant.toFixed(3)
                                        : item.montant.toFixed(3)}
                                    </td>
                                    <td style={{ fontSize: "15px" }}>
                                      {item.payment_method === "Cash"
                                        ? "Espèces"
                                        : item.payment_method}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            ),
                          )}
                        </React.Fragment>
                      );
                    },
                  )}
                </tbody>

                <tfoot>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Chiffre d'affaires :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {chiffreDAffaire.toFixed(3)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("total avances :")}{" "}
                    </td>

                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "avance")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("total encaissements :")}{" "}
                    </td>

                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "vente")}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total espéces :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "especes")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total Traite :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "Traite")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total Traite :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(
                        mouvementsCaisseParJournal,
                        "Carte sedexo",
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total Chèques : ")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "cheques")}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total points fidelité : ")}{" "}
                    </td>

                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(
                        mouvementsCaisseParJournal,
                        "Points fidelité",
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total tickets cadeaux :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "giftCard")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total Carte bancaire :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "creditCard")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total Bon :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "bon")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total apports :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateTotal(mouvementsCaisseParJournal, "apport")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total retraits :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {-CalculateTotal(mouvementsCaisseParJournal, "retrait")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Fond d'ouverture :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "end",
                      }}
                      colSpan={4}
                      onClick={() => setIsEditingFIni(true)}
                    >
                      {isEditingIni ? (
                        <input
                          className=""
                          type="number"
                          value={tempValueFini}
                          onChange={(e) => setTempValueFini(e.target.value)}
                          onBlur={() => handleBlur("font_initial")}
                          autoFocus
                          style={{
                            fontSize: "20px",
                            width: "100%",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "2px 4px",
                          }}
                        />
                      ) : (
                        <button
                          className="btn btn-info"
                          style={{ display: "flex" }}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ display: "flex", alignItems: "center" }}
                          ></i>
                          {(journal?.font_initial ?? 0).toFixed(3)}
                        </button>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={8}
                    >
                      {t("Total caisse :")}{" "}
                    </td>
                    <td
                      className="checkbox-column"
                      style={{ fontSize: "20px" }}
                      colSpan={4}
                    >
                      {CalculateRecette(
                        mouvementsCaisseParJournal,
                        journal?.font_initial,
                      )}
                    </td>
                  </tr>
                  {journal && journal.font_final > 0 ? (
                    <tr>
                      <td
                        className="checkbox-column"
                        style={{ fontSize: "20px" }}
                        colSpan={8}
                      >
                        Fond clôture :
                      </td>

                      <td
                        className="checkbox-column"
                        style={{
                          fontSize: "20px",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "end",
                        }}
                        colSpan={4}
                        onClick={() => setIsEditing(true)}
                      >
                        {isEditing ? (
                          <input
                            className=""
                            type="number"
                            value={tempValue}
                            onChange={(e) => setTempValue(e.target.value)}
                            onBlur={() => handleBlur("font_final")}
                            autoFocus
                            style={{
                              fontSize: "20px",
                              width: "100%",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "2px 4px",
                            }}
                          />
                        ) : (
                          <button
                            className="btn btn-info"
                            style={{ display: "flex" }}
                          >
                            <i
                              className="fas fa-edit"
                              style={{ display: "flex", alignItems: "center" }}
                            ></i>
                            {(journal?.font_final ?? 0).toFixed(3)}
                          </button>
                        )}
                      </td>
                    </tr>
                  ) : null}
                  {journal && journal.valide ? (
                    <tr>
                      <td
                        className="checkbox-column"
                        style={{ fontSize: "20px" }}
                        colSpan={8}
                      >
                        {t("Montant trouvé :")}{" "}
                      </td>
                      <td
                        className="checkbox-column"
                        style={{ fontSize: "20px" }}
                        colSpan={4}
                      >
                        {journal?.validatorFoundValue?.toFixed(3)}
                      </td>
                    </tr>
                  ) : null}
                  {journal && journal.cloture ? (
                    <tr>
                      <td
                        className="checkbox-column"
                        style={{ fontSize: "20px" }}
                        colSpan={8}
                      >
                        {t("Ecart :")}{" "}
                      </td>
                      <td
                        className="checkbox-column"
                        style={{ fontSize: "20px" }}
                        colSpan={4}
                      >
                        {journal && journal.ecart
                          ? Number(journal.ecart.toFixed(3)) > 0
                            ? ` + ${Number(journal.ecart.toFixed(3)) || 0}`
                            : Number(journal.ecart.toFixed(3)) || 0
                          : Number(
                              (CalculateRecette(
                                mouvementsCaisseParJournal,
                                journal?.font_initial,
                              ) -
                                (physicalCash + journal?.font_final)) *
                                -1,
                            ) > 0
                          ? `+ ${
                              Number(
                                (CalculateRecette(
                                  mouvementsCaisseParJournal,
                                  journal?.font_initial,
                                ) -
                                  (physicalCash + journal?.font_final)) *
                                  -1,
                              ).toFixed(3) || 0
                            }`
                          : Number(
                              (CalculateRecette(
                                mouvementsCaisseParJournal,
                                journal?.font_initial,
                              ) -
                                (physicalCash + journal?.font_final)) *
                                -1,
                            ).toFixed(3) || 0}
                      </td>
                    </tr>
                  ) : null}
                  {journal && journal.valide === false && journal.cloture ? (
                    parametrages && parametrages.methodeCloture === "total" ? (
                      <tr>
                        <td
                          className="checkbox-column"
                          style={{ fontSize: "20px", textAlign: "left" }}
                          colSpan={9}
                        >
                          <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            style={{ width: "100%" }}
                          >
                            {" "}
                            Valider
                          </button>
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td
                          className="checkbox-column"
                          style={{ fontSize: "20px" }}
                          colSpan={8}
                        >
                          <input
                            type="number"
                            className="form-control"
                            onChange={(e) =>
                              setPhysicalCash(Number(e.target.value))
                            }
                            value={
                              parametrages &&
                              parametrages.methodeCloture === "total"
                                ? journal?.font_final
                                : physicalCash
                            } // Use `value` instead of `defaultValue`
                          />
                        </td>
                        {journal && journal.cloture ? (
                          <td
                            className="checkbox-column"
                            style={{ fontSize: "20px", textAlign: "left" }}
                            colSpan={4}
                          >
                            <button
                              className="btn btn-primary"
                              onClick={handleSubmit}
                            >
                              {" "}
                              Valider
                            </button>
                          </td>
                        ) : null}
                      </tr>
                    )
                  ) : null}
                </tfoot>
              </table>
              <div className="row" style={{ justifyContent: "center" }}>
                {/* <button
                  className="btn btn-success mb-22"
                  style={{
                    width: "80%",
                    background: "#009688",
                  }}
                  onClick={(e) => (window.location.href = "/facture/" + id)}
                >
                  {t("Facture complète")}
                </button> */}
                {
                  <button
                    className="btn btn-success mb-22"
                    style={{
                      width: "80%",
                      background: "#009688",
                    }}
                    onClick={(e) =>
                      (window.location.href = "/factureSansEspeces/" + id)
                    }
                  >
                    {t("Facture")}
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <OrderDetailsModal
        show={showModalTicket}
        setShow={setShowModalTicket}
        order_id={selectedTicket}
      />
    </>
  );
};

export default MouvementsJournal;
